// extracted by mini-css-extract-plugin
export default {"body":"userBaneado_body__isEDe","baneado":"userBaneado_baneado__w0AWB","img":"userBaneado_img__tXo9R"};